import type { PageContext } from '@zto/zpage'
import { commonOptions } from '@/config/options'
import { SysConfigPaths, YesNo } from '@/config/enums'

export function buildingDialog(isEdit: boolean) {
  return {
    width: 700,
    labelWidth: 130,
    itemSpan: 24,
    title: isEdit ? '编辑楼栋' : '添加楼栋',
    onShow: async ({ app, data }: PageContext) => {
      if(!isEdit) return
      const id = data?.id
      const detail = await app.request({
        api: '/sys/admin/api/region/building/detail',
        method: 'POST',
        params: { id }
      })
      console.info('🚀 ~ file:_dialogs method:onShow line:19 ----- detail', detail)
      return {
        payload: {
          ...detail,
        }
      }
    },
    formItems: [
      {
        type: 'text',
        prop: 'buildingCode',
        label: '楼栋编码',
        visibleOn: `${isEdit}`
      },
      {
        type: 'fuzzy-select',
        prop: 'communityCode',
        labelProp: 'communityName',
        label: '所属小区',
        optionValueProp: 'communityCode',
        optionLabelProp: 'communityName',
        triggerFocus: true,
        required: true,
        remote: true,
        keywordProp: 'communityName',
        api:'/sys/admin/api/region/community/pageList',
        dynamicAttrs: ({ data, app }: PageContext) => {
          return {
            disabled: !!isEdit,
          }
        }
      },
      {
        type: 'fuzzy-select',
        prop: 'buildingName',
        label: '楼栋号',
        keywordProp: 'fuzzyName',
        api: '/sys/admin/config/dictItems',
        apiParams: {
          dictPath: SysConfigPaths.BUILDING_DICT,
          dataQuery:{
            conditions:[["tdlNumber","isNotEmpty"]]
          }
        },
        // labelProp: 'name',
        optionValueProp: 'name',
        optionLabelProp: 'name',
        triggerFocus: true,
        required: true,
        remote: true,
        autoHeight: true,
        collapseTags: false,
        multipleLimit: 100,
        dynamicAttrs: ({ data, app }: PageContext) => {
          return {
            multiple: !isEdit, // 编辑时 单选
            onChange: async (model: any, val: any, ctx: PageContext, ext: any) => {
              if (ext.options) {
                model.buildingList = ext.options.map((item: any) => {
                  return {
                    buildingName: item.name,
                    buildingNumber: item.data?.tdlNumber
                  }
                })
              }
            }
          }
        }
      },
      {
        type: 'input',
        prop: 'buildingNumber',
        label: '楼栋号通信码',
        trim: true,
        maxlength: 10,
        visibleOn: `${isEdit}`, // 编辑时 显示
        dynamicAttrs: ({ data, app }: PageContext) => {
          return {
            required: !!isEdit,
          }
        }
      },
      {
        type: 'fuzzy-select',
        prop: 'unitName',
        label: '单元',
        remote: true,
        keywordProp: 'fuzzyName',
        api: '/sys/admin/config/dictItems',
        apiParams: {
          dictPath: SysConfigPaths.UNIT_DICT,
          dataQuery:{
            conditions:[["tdlNumber","isNotEmpty"]]
          }
        },
        // labelProp: 'name',
        optionValueProp: 'name',
        optionLabelProp: 'name',
        triggerFocus: true,
        required: true,
        autoHeight: true,
        collapseTags: false,
        multipleLimit: 20,
        dynamicAttrs: ({ data, app }: PageContext) => {
          return {
            multiple: !isEdit, // 编辑时 单选
            onChange: async (model: any, val: any, ctx: PageContext, ext: any) => {
              if (ext.options) {
                model.unitList = ext.options.map((item: any) => {
                  return {
                    unitName: item.name,
                    unitNumber: item.data?.tdlNumber
                  }
                })
              }
            }
          }
        }
      },
      {
        type: 'input',
        prop: 'unitNumber',
        label: '单元通信码',
        trim: true,
        maxlength: 10,
        visibleOn: `${isEdit}`, // 编辑时 显示
        dynamicAttrs: ({ data, app }: PageContext) => {
          return {
            required: !!isEdit,
          }
        }
      },
      {
        type: 'input-number',
        prop: 'totalFloors',
        label: '最高楼层',
        min: 1,
        max: 100,
        precision: 0,
        default: 1
      },
      {
        type: 'checkbox',
        checkType: 'radio',
        prop: 'isMachineVehicleBuilding',
        label: '是否机器车楼栋',
        options: commonOptions.yesOrNo,
        default: YesNo.YES,
        required: true
      },
      {
        type: 'input-number',
        prop: 'elevatorCount',
        label: '电梯数量',
        min: 0,
        max: 99,
        precision: 0,
        default: 2
      }
    ],
    beforeSubmit: async ({ data }: PageContext, model: any, options: any) => {
      const { unitName, buildingName, buildingList, unitList, ...other} = data || {}
      if(!isEdit){
        return {
          ...other,
          buildingList,
          unitList
        }
      }
      const payload = {
        ...other,
        unitName,
        buildingName
      }
      console.info('🚀 ~ file:_dialogs method:beforeSubmit line:133 ----- payload', unitName, buildingName, payload)
      return payload
    },
    actions: {
      close: {},
      submit: { label: '确定' }
    }
  }
}
